<template>
  <footer>
    <div class="sp">
      <ul class="border-list">
        <li v-for="(menu, index) in menus" :key="menu.label">
          <button @click="handleToggle(index)">{{ menu.label }}<span><i :class="['fa-light', `fa-angle-${menu.angle}`]"></i></span></button>
          <ul class="child-list" :class="menu.show ? 'is-show' : ''" v-if="menu.children.length">
            <li v-for="child in menu.children" :key="child.label">
              <a :href="child.link" :target="child.target || '_self'">{{ child.label }}<i v-if="child.target && child.target === '_blank'" class="fa-light fa-arrow-up-right-from-square"></i></a>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="icon-list">
        <li v-for="icon in icons" :key="icon.name">
          <a :href="icon.link" target="_blank"><i :class="['fa-brands', `fa-${icon.name}`]"></i></a>
        </li>
      </ul>
      <div class="logo-container">
        <p>FROM <span>JAPAN</span> TO THE <span>WORLD</span></p>
      </div>
    </div>
    <div class="pc">
      <div class="list-wrapper">
        <div v-for="content in pc" :key="content.position" :class="content.position">
          <dl v-for="list in content.lists" :key="list.title">
            <dt>{{ list.title }}</dt>
            <dd>
              <ul>
                <li v-for="menu in list.menus" :key="menu.label">
                  <a :href="menu.link" :target="menu.target || '_self'">
                    <i v-if="menu.icon" :class="['fa-brands', `fa-${menu.icon}`]"></i>
                    {{ menu.label }}
                    <i v-if="!menu.icon && menu.target && menu.target === '_blank'" class="fa-light fa-arrow-up-right-from-square"></i>
                  </a>
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <p class="copyright"><span>&copy;</span>TOKYO BASE CO., LTD</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      menus: [
        // {
        //   show: false,
        //   angle: 'down',
        //   label: 'ヘルプ / ガイド',
        //   children: [
        //     {
        //       label: 'お問い合わせ',
        //       link: 'https://studious.co.jp/shop/contact/contact.aspx?',
        //     },
        //     {
        //       label: 'よくあるご質問',
        //       link: 'https://studious.co.jp/shop/pages/faq_st.aspx',
        //     },
        //     {
        //       label: 'ご利用規約',
        //       link: 'https://studious.co.jp/shop/pages/agree.aspx',
        //     },
        //     {
        //       label: '特定商取引法に基づく表記',
        //       link: 'https://studious.co.jp/shop/pages/tokutei.aspx',
        //     },
        //     {
        //       label: 'プライバシーポリシー',
        //       link: 'https://studious.co.jp/shop/pages/privacy.aspx',
        //     },
        //     {
        //       label: 'ショッピングガイド',
        //       link: 'https://studious.co.jp/shop/pages/sitemap_st.aspx',
        //     },
        //   ],
        // },
        {
          show: false,
          angle: 'down',
          label: '会社概要',
          children: [
            {
              label: '採用情報',
              link: 'https://tokyobase.co.jp/recruit/',
              target: '_blank',
            },
            {
              label: 'TOKYO BASE ホームページ',
              link: 'https://tokyobase.co.jp',
              target: '_blank',
            },
            {
              label: 'STUDIOUS 公式通販',
              link: 'https://studious.co.jp/',
              target: '_blank',
            },
            {
              label: 'UNITED TOKYO 公式通販',
              link: 'https://united-tokyo.com/',
              target: '_blank',
            },
            {
              label: 'PUBLIC TOKYO 公式通販',
              link: 'https://public-tokyo.com/',
              target: '_blank',
            },
            {
              label: 'CITY TOKYO 公式通販',
              link: 'https://citytokyo.com/',
              target: '_blank',
            },
            {
              label: 'THE TOKYO 公式通販',
              link: 'https://the-tokyo.jp/',
              target: '_blank',
            },
            {
              label: 'CONZ 公式通販',
              link: 'https://conz-tokyo.com/',
              target: '_blank',
            },
            {
              label: 'RITAN 公式通販',
              link: 'https://ritan-tokyo.com/',
              target: '_blank',
            },
          ],
        },
      ],
      icons: [
        {
          name: 'instagram',
          link: 'https://www.instagram.com/japan_edition_official/',
        },
        // {
        //   name: 'x-twitter',
        //   link: '#',
        // },
      ],
      pc: [
        {
          position: 'left',
          lists: [
            {
              title: 'OFFICIAL SNS',
              menus: [
                {
                  icon: 'instagram',
                  label: 'instagram',
                  link: 'https://www.instagram.com/japan_edition_official/',
                  target: '_blank',
                },
              ],
            },
            {
              title: 'ONLINE STORE',
              menus: [
                {
                  label: 'STUDIOUS',
                  link: 'https://studious.co.jp/',
                  target: '_blank',
                },
                {
                  label: 'UNITED TOKYO',
                  link: 'https://united-tokyo.com/',
                  target: '_blank',
                },
                {
                  label: 'PUBLIC TOKYO',
                  link: 'https://public-tokyo.com/',
                  target: '_blank',
                },
                {
                  label: 'CITY TOKYO',
                  link: 'https://citytokyo.com/',
                  target: '_blank',
                },
                {
                  label: 'THE TOKYO',
                  link: 'https://the-tokyo.jp/',
                  target: '_blank',
                },
                {
                  label: 'CONZ',
                  link: 'https://conz-tokyo.com/',
                  target: '_blank',
                },
                {
                  label: 'RITAN',
                  link: 'https://ritan-tokyo.com/',
                  target: '_blank',
                },
              ],
            },
          ],
        },
        {
          position: 'right',
          lists: [
            {
              title: 'COMPANY',
              menus: [
                {
                  label: '採用情報',
                  link: 'https://tokyobase.co.jp/recruit/',
                  target: '_blank',
                },
                {
                  label: 'TOKYO BASE 企業サイト',
                  link: 'https://tokyobase.co.jp/',
                  target: '_blank',
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleToggle(index) {
      const target = this.menus[index];
      target.show = !target.show;
      target.angle = target.show ? 'up' : 'down';
    },
  },
};
</script>

<style scoped lang="scss">
.border-list {
  > li {
    border-top: 1px solid #ccc;
    &:last-child {
      border-bottom: 1px solid #ccc;
    }
  }
  button, a {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 1.4em 1.8em;
    span {
      margin-left: auto;
    }
  }
}
.child-list {
  background-color: #eee;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s;

  &.is-show {
    max-height: 100vh;
  }

  > li {
    &:not(:first-child) {
      border-top: 1px solid white;
    }
    &:first-child {
      border-top: 1px solid #ccc;
    }
  }
  i {
    margin-left: .5em;
    font-size: .8em;
  }
}

.icon-list {
  margin-top: 4em;
  display: flex;
  align-items: center;
  justify-content: center;
  li {
    font-size: 2em;
    &:not(:first-child) {
      margin-left: .5em;
    }
  }
}

.logo-container {
  margin-top: 2em;
  p {
    font-size: .9em;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  span {
    font-size: 1.3rem;
    font-weight: bold;
    margin: 0 .3rem;
  }
}

.copyright {
  font-size: .8em;
  font-weight: bold;
  margin: 2em 0 5em;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 1.4em;
    margin-right: .2em;
  }
}

@media screen and (min-width: 768px) {
  .list-wrapper {
    display: flex;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    > div {
      padding: 3em 4em;
    }
    .left {
      width: 65%;
      display: flex;
      justify-content: flex-end;
      li {
        font-size: .9em;
      }
    }
    .right {
      width: 35%;
      border-left: 1px solid #ccc;
      flex: 1;
      ul {
        max-width: 250px;
      }
      li {
        padding-bottom: .5em;
        border-bottom: 1px solid #333;
      }
      a {
        .fa-arrow-up-right-from-square {
          margin-left: auto;
          margin-right: 1em;
        }
      }
    }
    dl {
      &:not(:first-child) {
        margin-left: 4em;
      }
      dt {
        font-weight: bold;
        margin-bottom: 2em;
      }
      li {
        a {
          width: 100%;
          display: flex;
          align-items: center;
          .fa-instagram {
            margin-right: .5em;
          }
          .fa-arrow-up-right-from-square {
            font-size: .6em;
            margin-left: 1em;
          }
        }
        &:hover {
          text-decoration: underline;
        }
        &:not(:first-child) {
          margin-top: 1em;
        }
      }
    }
  }

  .copyright {
    color: #999;
    margin-right: 4em;
    justify-content: flex-end;
  }
}

</style>
